
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/en",
      function () {
        return require("private-next-pages/terms/en.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/en"])
      });
    }
  